/// <reference path="../../typings/browser.d.ts" />

namespace Application.Models {
    'use strict';
    
    import IBlock = Models.IBlock;

    export interface IBlockConnections {
        name: string;
        blockHref: string;
        connectionsAvailable: number;
        availableConnections: boolean;
        block: IBlock;
        blockTypeConnectionType:  IBlockTypeConnectionType;
        connectionTypeName?: string;
        direction?: string;
        id?: number;
        push?: boolean;
        targetPorts?: string;
        parameters?: IBlockConnectionParameters;
        connected?: boolean;

    }
    export interface IUpdateBlockConnection {
        id: number;
        targetPorts: string;
        parameters: IBlockConnectionParameters;
    }

    interface IBlockConnectionParameters {
        passphrase: string; 
        url?: string;
    }

    export class BlockConnections implements IBlockConnections {
        public name: string;
        public href: string;
        public blockHref: string;
        public connectionsAvailable: number;
        public availableConnections: boolean;
        public block: IBlock;
        public blockTypeConnectionType: IBlockTypeConnectionType;
        public parameters: IBlockConnectionParameters

        public static Empty(): BlockConnections {
            return new BlockConnections();
        }

        constructor() {
            // empty constructor
            this.name = '';
        }

        public static DIRECTION_OUTPUT: string = "OUTPUT";
        public static DIRECTION_INPUT: string = "INPUT";
    }
}


